import { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import AuthLayout from "@/pages/layouts/AuthLayout";
import ProtectedRoute from "@/pages/layouts/ProtectedRoute";
import AdminRoute from "@/pages/layouts/AdminRoute";
import { DashboardLayout } from "@/pages/layouts/DashboardLayout";

const LandingPage = lazy(() => import("@/pages/landing/LandingPage"));
const LoginPage = lazy(() => import("@/pages/auth/LoginPage"));
const RegisterPage = lazy(() => import("@/pages/auth/RegisterPage"));
const SubmitPage = lazy(() => import("@/pages/submit/SubmitPage"));
const DashboardPage = lazy(() => import("@/pages/dashboard/DashboardPage"));
const ApplicationDetailPage = lazy(() => import("@/pages/dashboard/ApplicationDetailPage"));
const AdminStatsPage = lazy(() => import("@/pages/admin/AdminStatsPage"));
const PrivacyPage = lazy(() => import("@/pages/legal/PrivacyPage"));
const TermsPage = lazy(() => import("@/pages/legal/TermsPage"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));

export const router = createBrowserRouter([
  {
    element: <App />,
    children: [
      { index: true, element: <LandingPage /> },
      { path: "submit", element: <SubmitPage /> },
      { path: "privacy", element: <PrivacyPage /> },
      { path: "terms", element: <TermsPage /> },
      {
        element: <AuthLayout />,
        children: [
          { path: "login", element: <LoginPage /> },
          { path: "register", element: <RegisterPage /> },
        ],
      },
      {
        element: <ProtectedRoute />,
        children: [
          {
            element: <DashboardLayout />,
            children: [
              { path: "dashboard", element: <DashboardPage /> },
              { path: "dashboard/applications/:id", element: <ApplicationDetailPage /> },
              {
                element: <AdminRoute />,
                children: [
                  { path: "admin/stats", element: <AdminStatsPage /> },
                ],
              },
            ],
          },
        ],
      },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
